module.exports = __webpack_public_path__ + "static/img/19.cc8dbd40.jpg";